import { FaCar, FaSmile, FaCalendarAlt, FaMapMarkedAlt } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaCar />, // Car Icon
        title: 'Cars Available',
        count: '500',
    },
    {
        id: 2,
        icon: <FaSmile />, // Smile Icon for Satisfied Clients
        title: 'Satisfied Clients',
        count: '15000',
    },
    {
        id: 3,
        icon: <FaCalendarAlt />, // Calendar Icon for Years in Business
        title: 'Years in Business',
        count: '8',
    },
    {
        id: 4,
        icon: <FaMapMarkedAlt />, // Map Icon for Locations Served
        title: 'Locations Served',
        count: '25',
    },
];

export default counter;